export default __webpack_public_path__ + "static/media/bannerImageLanding.cdb163f1.png";